import React from 'react'

interface Props {
    children: React.ReactNode
}

const ContentContainer: React.VFC<Props> = ({ children }: Props) => <main>{children}</main>

export default ContentContainer
